import { Form } from 'react-final-form';
import { Stack, Unstable_Grid2 as Grid } from '@mui/material';

import { Button, Divider, Typography } from '@occc/ui-design-system';
import { Select } from '@occc-app/design-system';
import { DatetimeRangeFields, makeZodValidate } from '@occc/ui-forms';

import { MESSAGE_TYPE_OPTIONS, STATUS_OPTIONS } from './messaging-campaigns-filter.constants';
import { MessagingCampaignsFilterSchema } from './messaging-campaigns-filter.schema';
import { MessagingCampaignsFilterFormValues } from './messaging-campaigns-filter.types';

const validateFilterForm = makeZodValidate(MessagingCampaignsFilterSchema);

export type MessagingCampaignsFilterContainerProps = {
  value?: MessagingCampaignsFilterFormValues;
  onChange?: (value: MessagingCampaignsFilterFormValues) => void;
};

export const MessagingCampaignsFilterContainer = (
  props: MessagingCampaignsFilterContainerProps,
) => {
  const { onChange, value } = props;
  return (
    <Stack gap={3} p={3}>
      <Typography variant='h6'>Filter SMS / Push Notifications</Typography>
      <Form<MessagingCampaignsFilterFormValues>
        initialValues={value}
        onSubmit={(values) => {
          onChange?.(values);
        }}
        validate={validateFilterForm}
        render={(props) => {
          const onReset = () => {
            // Reset form to empty state! Not to initial values
            props.form.reset({});
            props.form.submit();
          };
          return (
            <form onSubmit={props.handleSubmit}>
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <Select
                    name={'messageTypeEquals' satisfies keyof MessagingCampaignsFilterFormValues}
                    label={'Message Type'}
                    data={MESSAGE_TYPE_OPTIONS}
                  />
                </Grid>
                <Grid xs={12}>
                  <Select
                    name={'statusEquals' satisfies keyof MessagingCampaignsFilterFormValues}
                    label='Status'
                    data={STATUS_OPTIONS}
                    formControlProps={{ size: 'medium', margin: 'none' }}
                  />
                </Grid>

                <Grid xs={12}>
                  <Divider />
                </Grid>

                <DatetimeRangeFields<keyof MessagingCampaignsFilterFormValues>
                  modeFieldName='scheduledAt'
                  modeFieldLabel='Scheduled / Sent'
                  modeFieldValue={props.values.scheduledAt}
                  fromFieldName={'scheduledDateFrom'}
                  toFieldName={'scheduledDateTo'}
                />
                <Grid xs={12}>
                  <Divider />
                </Grid>

                <Grid xs={12}>
                  <Stack direction='row' spacing={2} justifyContent='flex-end'>
                    <Button variant='text' onClick={onReset}>
                      Reset
                    </Button>

                    <Button
                      variant='contained'
                      type='submit'
                      disabled={props.hasValidationErrors || props.pristine}
                    >
                      Apply
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </form>
          );
        }}
      />
    </Stack>
  );
};
